export const editor = {
  root: () => ({
    class: ['rounded-lg border border-grey-300 bg-white'],
  }),
  toolbar: () => ({
    class: [
      'flex flex-wrap items-center gap-4 border-x-0 border-b border-t-0 border-grey-300',
      '*:m-0',
    ],
  }),
  content: () => ({
    class: ['border-none'],
    role: 'textbox',
  }),
};
